<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>上级分销商列表</el-breadcrumb-item> 
    </el-breadcrumb>
    <el-card style="margin-top:20px">
      <div class="titleStyle">
        <el-input placeholder="	分销商名称" v-model="data.name"></el-input>
        <el-button @click="chaxun">查询</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="DistributorID" label="上级分销商ID">
          </el-table-column>
          <el-table-column prop="Name" label="简称"></el-table-column>
          <el-table-column prop="LinkMan" label="联系人"></el-table-column>
          <el-table-column prop="Phone" label="联系电话"></el-table-column>
          <el-table-column prop="E_Mail" label="E-mail"></el-table-column>
          <el-table-column prop="Status" label="状态">
            <template slot-scope="scope">
              <img src="@/assets/dhl.png" alt v-if="scope.row.Status=='1'"/>
              <img src="@/assets/xhh.png" alt v-if="scope.row.Status=='2'" />
            </template>
          </el-table-column>
          <el-table-column prop="Balance" label="余额"></el-table-column>
          <el-table-column prop="OverDraftMoney" label="透支额度">
              <template slot-scope="scope">
                  <span>{{ scope.row.OverDraftFlag==0?'不可透支':scope.row.OverDraftMoney }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="AlreadyOverdraft" label="已透支">
            <template slot-scope="scope">
                <span>{{ scope.row.AlreadyOverdraft==null?0:scope.row.AlreadyOverdraft }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="Distributor(scope.row)">详情</el-button>
              <el-button type="text" @click="views(scope.row)">查看产品</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{data.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="data.total" :current-page.sync="data.page"  ></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-card>
    <!-- 产品列表弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="详情"
      :visible.sync="shopListVisible"
      :before-close="shopListHandleClose"
      width="50%"
      center
    >
      <el-divider></el-divider>
      <div>
        <el-form :model="ruleForm"  ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <div class="formFlex">
              <el-form-item label="上级分销商ID：" >
                <el-input  v-model="ruleForm.DistributorID" disabled autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="简称：" >
                <el-input  v-model="ruleForm.FullName" disabled autocomplete="off"></el-input>
              </el-form-item>
            </div>
          <el-form-item label="全称：">
            <el-input  v-model="ruleForm.Name" disabled autocomplete="off"></el-input>
          </el-form-item>
          <div class="formFlex">
            <el-form-item label="联系人：">
              <el-input  v-model="ruleForm.LinkMan" disabled autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" >
              <el-input  v-model="ruleForm.Phone" disabled autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="E-mail：" >
              <el-input  v-model="ruleForm.E_Mail" disabled autocomplete="off"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="地址：" >
            <el-input  v-model="ruleForm.Address" disabled autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDistributorTwoInfo ,getParentDistributorList,getParentDistributorInfo} from '@/request/index.js'
  export default{
    data(){
      return{
        ruleForm:{
          DistributorID:'',
          Name:'',
          FullName:'',
          LinkMan:'',
          Phone:'',
          E_Mail:'',
          Address:''
        },
        data:{
          token:window.sessionStorage.getItem('Token'),
          name:'',
          page:1,
          page_size:10,
          total:0
        },
        tableData:[],
        shopListVisible:false
      }
    },
    created(){
      this.getList()
      this.getDisList()
    },
    methods:{
      chaxun(){
        this.getDisList()
      },
      views(row){
        this.$router.push({path: '/product', query: {id:row.DistributorID}});
      },
      Distributor(row){
        this.shopListVisible = true
        let data  = {
          token:window.sessionStorage.getItem('Token'),
          d_id:row.DistributorID
        }
        getParentDistributorInfo(data).then(res=>{
          if(res.data.status=='ok'){
            this.ruleForm = res.data.result
          }
        })
      },
      shopListHandleClose(){
        this.shopListVisible = false
      },
      getDisList(){
        getParentDistributorList(this.data).then(res=>{
          console.log(res)
          if(res.data.status=='ok'){
            this.tableData = res.data.result.data
            this.data.total = res.data.result.total
          }
        })
      },
      getList(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
        }
        getDistributorTwoInfo(data).then(res=>{
          if(res.data.status=='ok'){
            window.sessionStorage.setItem("ids", res.data.result.DistributorID);
            window.sessionStorage.setItem("name", res.data.result.FullName);
          }
        })
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
    }
  }
</script>
<style scoped lang="less">
  .pagination{
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.titleStyle {
  margin-bottom: 20px;
  .el-input {
    width: 250px;
    height: 40px;
    margin-right: 20px;
  }
  .el-select {
    width: 260px;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
  }
}
.formFlex{
  display: flex;
  flex-wrap: wrap;
}
.el-dialog__wrapper /deep/ .el-input input{
  background-color: #FFF !important;
}
</style>